import { App as BEC } from './TopEmmissionsChart/appDeclaration'
import { App as PortfolioEnergyChart } from './PortfolioEnergyChart/appDeclaration'
import { App as Heatmap } from './EnergyHeatmap/appDeclaration';
import { App as BuildingsCompare, AppOld as BuildingsCompareOld } from './BuildingsCompare/appDeclaration'

export const Apps = {
    [BEC.schema]: BEC,
    [Heatmap.schema]: Heatmap,
    [BuildingsCompare.schema]: BuildingsCompare,
    [BuildingsCompareOld.schema]: BuildingsCompareOld,
    [PortfolioEnergyChart.schema]: PortfolioEnergyChart,
}
